/*
 * @Author: zl21 602659667@qq.com
 * @Date: 2025-06-10 16:58:19
 * @LastEditors: zl21 602659667@qq.com
 * @LastEditTime: 2026-09-08 16:25:31
 * @FilePath: /r3-threegun-web/src/config/minxin/subTableFormLinkage.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 主子表表单联动
 *
 * 1. 联动隐藏/显示，元数据按照主表的配，子表字段不能与主表相同，不然区分不出是对子表的操作
 *    eg. 客户订单单对象 - 发票类型=999 - 隐藏子表(商品信息)的'销售价'
 */

import SG_C_PRODUCT_EXCLUSIVE_STRATEGY_ITEM from './standardTable/details/SG_C_PRODUCT_EXCLUSIVE_STRATEGY_ITEM'
import ST_C_INITIAL_SHARE_ITEM from './standardTable/details/ST_C_INITIAL_SHARE_ITEM'

export default () => ({
  mixins: [
    SG_C_PRODUCT_EXCLUSIVE_STRATEGY_ITEM,
    ST_C_INITIAL_SHARE_ITEM,
  ],
  data() {
    return {}
  },
  watch: {},
  created() { },
  updated() { },
  mounted() {
    window.addEventListener("notificationOfMain", ({ detail, item }) => {
      const { tableName, itemId } = vm.$route.params
      console.log('/////::', detail, tableName, itemId);
      if (itemId != 'New') {
        const tabColConf = {
          DC_B_ORDER: ['CP_CCUSTOMER_ID', 'ST_C_BUSINESS_TYPE_ID', 'CP_C_DISCOUNT_TYPE_ID','ORDER_DATE'],
          DC_B_ORDER_SEND: ['RECEIVE_CP_C_CUSTOMER_ID', 'ST_C_BUSINESS_TYPE_ID', 'CP_C_DISCOUNT_TYPE_ID', 'BILL_DATE'],
        }
        if (tabColConf[tableName]) {
          const cols = tabColConf[tableName]
          if (cols.includes(detail.item.colname)) {
            $fcWarn({
              className: 'ark-dialog',
              title: $it('mT.tips'), // 提示
              content: `确定重新匹配策略？`,
              mask: true,
              showCancel: true,
              onOk: () => {
                localStorage.setItem('DC_B_ORDER_STRATEGY_CONFIRM', 'true')
                $('.R3-buttonList #actionMODIFY')[0].click()
              }
            });
          }
        }
      }
      if (detail.hasOwnProperty('INVOICE_TYPE')) {
        switch (detail.INVOICE_TYPE) {
          case 999:
            const page = vm.$store.state[R3.getModuleName()]
            const nowTabForm = _.cloneDeep(page.tabPanels[page.tabCurrentIndex].componentAttribute.formData.data.inpubobj)
            nowTabForm.forEach((it, dex) => {
              if (it.colname == "PRICE_SALE") {
                it.show = false
              }
            });
            // this.updateFormDataForRefTable(nowTabForm);
            const newData = {
              tabIndex: page.tabCurrentIndex,
              inpubobj: nowTabForm
            }
            $store.commit(`${R3.getModuleName()}/updateFormDataForRefTable`, newData)
            break;
          default:
            break;
        }
      }
    }, false);
  },
  methods: {
    /* ...mapMutations(R3.getModuleName(), [
      'updateFormDataForRefTable'
    ]) */
  },
})
